const options = {
  5: "bg-slate-700/5",
  10: "bg-slate-700/10",
  25: "bg-slate-700/25",
  50: "bg-slate-700/50",
  75: "bg-slate-700/75",
  90: "bg-slate-700/90",
  100: "bg-slate-700",
};

const from = {
  5: "from-slate-700/5",
  10: "from-slate-700/10",
  25: "from-slate-700/25",
  50: "from-slate-700/50",
  75: "from-slate-700/75",
  90: "from-slate-700/90",
  100: "from-slate-700",
};

export default function getBackgroundSlate700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
